import axiosClient from "../axiosClient";
import { Produit } from "../interfaces/produit.interface";

export const findAllProduits = async () => {
  const { data } = await axiosClient.get<Produit[]>("/produits");
  return data;
};

export const findAllAchats = async () => {
  const { data } = await axiosClient.get<Produit[]>("/produits/achats");
  return data;
};
